"use strict";

exports.__esModule = true;
exports.default = exports.Scaffolding = exports.Searcher = exports.Basic = void 0;

var _styledComponents = require("styled-components");

var _styles = require("../styles");

function _templateObject19() {
  var data = _taggedTemplateLiteralLoose(["\n    margin-top: 10px;\n    padding: 15px 30px;\n  "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid #DBE0E4;\n    border-left: 1px solid #DBE0E4;\n    border-right: 1px solid #DBE0E4;\n\n    font-style: normal;\n    font-weight: 325;\n    font-size: 14px;\n    line-height: 21px;\n    letter-spacing: -0.3px;\n    color: ", ";\n\n    margin-top: 0px;\n    padding: 0px 30px;\n    box-sizing: border-box;\n  "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteralLoose(["\n    margin-top: 6px;\n    background: #FFEAD3;\n    .tab-arrow {\n      transform: rotate(180deg);\n    }\n  "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    font-style: normal;\n    font-weight: 325;\n    font-size: 14px;\n    line-height: 21px;\n    letter-spacing: -0.3px;\n    color: ", ";\n    margin-top: 6px;\n    padding: 6px 16px;\n    cursor: pointer;\n    transition:  background .5s, margin .5s;\n\n    .tab-arrow {\n      transition: 0.5s all ease;\n    }\n\n    :hover {\n      background: rgba(247, 142, 33, 0.05);\n    }\n\n    &[open]:hover {\n      background: #FFEAD3;\n    }\n  "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteralLoose(["\n    background-color: white;\n    display: block;\n  "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: white;\n    svg {\n      height: 23px;\n      #arrowDown path {\n        fill: ", ";\n      }\n    }\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n    font-size: 14px;\n    color: ", ";\n    margin-right: 10px;\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n    padding: 10px 20px;\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n    padding: 0px 20px;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n    .tab-arrow {\n      transform: rotate(180deg);\n    }\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    font-size: 16px;\n    font-weight: bold;\n    color: ", ";\n    padding: 10px 20px;\n    cursor: pointer;\n\n    .tab-arrow {\n      transition: 0.5s all ease;\n    }\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n    background-color: white;\n    border-left: 1px solid ", ";\n    border-right: 1px solid ", ";\n\n    &:first-child {\n      border: 0px 1px 0px 1px solid ", ";\n    }\n    &:last-child {\n      border: 0px 1px 0px 1px solid ", ";\n    }\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n    box-shadow: 0px 15px 25px -15px ", ";\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n    padding: 10px 20px;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n    padding: 0px 20px;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid ", ";\n\n    .tab-arrow {\n      transform: rotate(180deg);\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    font-size: 24px;\n    font-weight: bold;\n    color: ", ";\n    padding: 10px 20px;\n    cursor: pointer;\n\n    .tab-arrow {\n      transition: 0.5s all ease;\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    background-color: white;\n    border-left: 1px solid ", ";\n    border-right: 1px solid ", ";\n\n    &:first-child {\n      border: 1px solid ", ";\n      border-top-left-radius: 4px;\n      border-top-right-radius: 4px;\n    }\n    &:last-child {\n      border: 1px solid ", ";\n      border-bottom-left-radius: 4px;\n      border-bottom-right-radius: 4px;\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    box-shadow: 0px 15px 25px -15px ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var KineduPalette = _styles.colorPalettes.KineduPalette;
var Basic = {
  container: (0, _styledComponents.css)(_templateObject(), KineduPalette.shadeDark),
  panel: (0, _styledComponents.css)(_templateObject2(), KineduPalette.shadeMedium, KineduPalette.shadeMedium, KineduPalette.shadeMedium, KineduPalette.shadeMedium),
  label: (0, _styledComponents.css)(_templateObject3(), KineduPalette.kinedu),
  openLabel: (0, _styledComponents.css)(_templateObject4(), KineduPalette.shadeMedium),
  content: (0, _styledComponents.css)(_templateObject5()),
  openContent: (0, _styledComponents.css)(_templateObject6())
};
exports.Basic = Basic;
var Searcher = {
  container: (0, _styledComponents.css)(_templateObject7(), KineduPalette.shadeDark),
  panel: (0, _styledComponents.css)(_templateObject8(), KineduPalette.shadeMedium, KineduPalette.shadeMedium, KineduPalette.shadeMedium, KineduPalette.shadeMedium),
  label: (0, _styledComponents.css)(_templateObject9(), KineduPalette.shadeDark),
  openLabel: (0, _styledComponents.css)(_templateObject10()),
  content: (0, _styledComponents.css)(_templateObject11()),
  openContent: (0, _styledComponents.css)(_templateObject12()),
  iconTitle: (0, _styledComponents.css)(_templateObject13(), KineduPalette.kinedu)
};
exports.Searcher = Searcher;
var Scaffolding = {
  container: (0, _styledComponents.css)(_templateObject14(), KineduPalette.shadeDark),
  panel: (0, _styledComponents.css)(_templateObject15()),
  label: (0, _styledComponents.css)(_templateObject16(), KineduPalette.shadeDark),
  openLabel: (0, _styledComponents.css)(_templateObject17()),
  content: (0, _styledComponents.css)(_templateObject18(), KineduPalette.shadeDark),
  openContent: (0, _styledComponents.css)(_templateObject19())
};
exports.Scaffolding = Scaffolding;
var _default = {
  Basic: Basic,
  Searcher: Searcher,
  Scaffolding: Scaffolding
};
exports.default = _default;